export interface Article {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  author: string;
  publishDate: string;
  readCount: number;
  tags: string[];
  isHot: boolean;
  isFeatured: boolean;
  isDaily: boolean;
}

export const categories: { name: string; slug: string; icon: string; description: string }[] = [
  { name: '娱乐八卦', slug: 'yule-bagua', icon: 'ri-star-line', description: '明星八卦、娱乐绯闻、圈内秘事，最新最热的娱乐吃瓜内容尽在这里' },
  { name: '社会热点', slug: 'shehui-redian', icon: 'ri-fire-line', description: '社会事件、热点新闻、民生话题，全网热议的社会吃瓜事件实时追踪' },
  { name: '明星动态', slug: 'mingxing-dongtai', icon: 'ri-user-star-line', description: '明星行程、作品发布、生活日常，一手掌握娱乐圈明星最新动态' },
  { name: '综艺节目', slug: 'zongyi-jiemu', icon: 'ri-tv-line', description: '综艺节目爆料、幕后花絮、嘉宾八卦，热门综艺吃瓜内容一网打尽' },
  { name: '影视资讯', slug: 'yingshi-zixun', icon: 'ri-film-line', description: '影视剧集资讯、票房数据、影评热议，影视圈最新吃瓜资源合集' },
  { name: '网红爆料', slug: 'wanghong-baoliao', icon: 'ri-live-line', description: '网红圈内幕、直播爆料、短视频热点，网红世界的吃瓜内容每日更新' },
];

export const articles: Article[] = [
  {
    id: '1',
    title: '某顶流男星深夜密会神秘女子，疑似新恋情曝光',
    slug: 'top-star-secret-date',
    excerpt: '据知情人士透露，某当红流量男星近日被拍到深夜与一名神秘女子同回公寓，两人举止亲密，疑似新恋情浮出水面。粉丝纷纷表示不敢相信，评论区已炸锅。',
    content: `<p>近日，有媒体拍到某顶流男星深夜与一名神秘女子一同返回某高档公寓的画面。据目击者透露，两人全程举止亲密，男方还贴心地为女方披上外套，二人有说有笑，看起来关系非同一般。</p><p>消息一出，立刻在各大社交平台引发热议。该男星的粉丝群体迅速分化为两派：一派表示"祝福哥哥找到真爱"，另一派则质疑女方身份，甚至有人扒出女方疑似为某网红主播。</p><p>截至目前，该男星及其工作室尚未对此事作出回应。但据圈内人士透露，二人确实已经交往数月，只是由于男方正处于事业上升期，一直未公开恋情。</p><p>值得一提的是，这已经不是该男星第一次被拍到与女性友人同行。去年底他就曾被拍到与另一位女演员共进晚餐，不过当时工作室迅速发声明澄清"只是普通朋友聚餐"。</p><p>吃瓜群众纷纷表示：这次不知道会不会又是"普通朋友"呢？让我们拭目以待。</p>`,
    category: '娱乐八卦',
    categorySlug: 'yule-bagua',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20entertainment%20news%20style%20image%20of%20a%20popular%20male%20celebrity%20walking%20at%20night%20with%20mysterious%20atmosphere%2C%20paparazzi%20style%20photography%2C%20warm%20street%20lights%2C%20modern%20urban%20setting%2C%20cinematic%20mood%2C%20soft%20bokeh%20background&width=800&height=450&seq=article-cover-01&orientation=landscape',
    author: '吃瓜小编',
    publishDate: '2026-08-04',
    readCount: 128530,
    tags: ['顶流男星', '恋情曝光', '深夜密会', '娱乐圈'],
    isHot: true,
    isFeatured: true,
    isDaily: true,
  },
  {
    id: '2',
    title: '热播剧《星辰大海》大结局引发争议，编剧亲自回应',
    slug: 'starry-sea-finale-controversy',
    excerpt: '年度热播剧《星辰大海》昨晚迎来大结局，出乎意料的结局走向引发观众两极分化评价。编剧凌晨发文回应质疑，称"结局是角色的必然选择"。',
    content: `<p>年度热播都市情感剧《星辰大海》昨晚迎来大结局，收视率再创新高。然而，剧中男女主角最终未能在一起的结局引发了观众强烈不满。</p><p>大量观众在社交平台表达失望之情："追了三个月就给我看这个？""编剧你是不是对爱情有什么误解？"相关话题迅速登上热搜榜首。</p><p>面对汹涌的质疑声，该剧总编剧王明远凌晨发长文回应。他表示："这不是一个关于'在一起'的故事，而是关于成长的故事。每个角色在大结局中做出的选择，都是他们人生轨迹的必然结果。我希望观众能跳出'CP结局'的思维定式，去理解角色内心的成长。"</p><p>不过也有不少观众表示支持编剧的决定。"这就是现实啊，不是所有的爱情都会有圆满的结局。""看完内心很震撼，这才是好剧该有的样子。"</p><p>据悉，《星辰大海》目前正在筹备电影版，编剧透露电影版将有全新的故事线，或许会给观众一个不一样的交代。</p>`,
    category: '影视资讯',
    categorySlug: 'yingshi-zixun',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20TV%20drama%20promotional%20poster%20style%20image%20with%20emotional%20couple%20silhouette%20against%20starry%20night%20sky%2C%20romantic%20drama%20aesthetic%2C%20warm%20golden%20lighting%2C%20cinematic%20composition%2C%20soft%20and%20dreamy%20atmosphere&width=800&height=450&seq=article-cover-02&orientation=landscape',
    author: '影视观察员',
    publishDate: '2026-08-04',
    readCount: 98210,
    tags: ['星辰大海', '电视剧', '大结局', '争议'],
    isHot: true,
    isFeatured: true,
    isDaily: false,
  },
  {
    id: '3',
    title: '某知名女星被曝税务问题，工作室紧急发声明',
    slug: 'actress-tax-issue',
    excerpt: '网上突然爆出某知名女演员涉嫌税务问题的传闻，引发网友广泛关注。其工作室火速发布声明称"纯属造谣"，并表示已委托律师取证。',
    content: `<p>今日上午，一则关于某知名女演员涉嫌税务问题的爆料在网络上迅速传播。爆料称该女星通过多种方式规避个人所得税，涉及金额巨大。</p><p>消息传出后，该女星的工作室在短短两小时内即发布正式声明，称相关爆料"纯属恶意造谣"，并表示已委托律师事务所进行取证，将追究造谣者的法律责任。</p><p>声明中还提到，该女星一直以来都是依法纳税的模范公民，所有收入和税务申报均有据可查，经得起任何形式的核查。</p><p>对此，网友们反应不一。有支持者表示"造谣一张嘴，辟谣跑断腿"，呼吁严惩造谣者；也有网友持观望态度："让子弹再飞一会儿，毕竟之前也有类似'辟谣'最后被打脸的例子。"</p><p>截至目前，税务部门尚未对此事作出回应。</p>`,
    category: '娱乐八卦',
    categorySlug: 'yule-bagua',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20celebrity%20news%20style%20image%20with%20elegant%20actress%20at%20press%20conference%2C%20serious%20expression%2C%20professional%20studio%20lighting%2C%20clean%20modern%20background%2C%20editorial%20photography%20style&width=800&height=450&seq=article-cover-03&orientation=landscape',
    author: '深度八卦',
    publishDate: '2026-08-03',
    readCount: 156720,
    tags: ['知名女星', '税务问题', '工作室声明', '辟谣'],
    isHot: true,
    isFeatured: true,
    isDaily: true,
  },
  {
    id: '4',
    title: '2026下半年最受期待综艺节目排名出炉',
    slug: '2026-variety-show-ranking',
    excerpt: '业内权威媒体发布了2026下半年最受观众期待的综艺节目排名，多档新节目引发热议。音乐竞演类节目再度成为观众最期待的综艺类型。',
    content: `<p>近日，业内权威媒体发布了2026下半年最受观众期待的综艺节目Top10榜单。榜单显示，音乐竞演类节目再度成为观众最期待的综艺类型，占据了榜单半数席位。</p><p>排名第一的是全新原创音乐竞演节目《声入人心2026》，该节目邀请到了多位国际知名音乐人担任导师，备受瞩目。紧随其后的是户外真人秀《荒野挑战者》第二季，以及推理游戏类节目《密室逃脱：终极对决》。</p><p>值得注意的是，今年多档节目都采用了"全明星+素人"的新模式，业内人士认为这是综艺市场转型的一个重要信号。"单纯的明星阵容已经不足以吸引观众，内容的创新和深度的挖掘才是关键。"一位资深综艺制作人这样评价。</p><p>此外，榜单中还有两档聚焦社会议题的新型综艺，如关注职场新人成长的《第一份工作》，以及探讨代际关系的《我和我的父母》，显示出综艺节目正在从纯娱乐向深度内容转型的趋势。</p>`,
    category: '综艺节目',
    categorySlug: 'zongyi-jiemu',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20stage%20design%20with%20colorful%20lighting%20and%20modern%20set%2C%20entertainment%20show%20atmosphere%2C%20dynamic%20stage%20lights%2C%20professional%20broadcast%20studio%2C%20vibrant%20and%20energetic%20mood&width=800&height=450&seq=article-cover-04&orientation=landscape',
    author: '综艺达人',
    publishDate: '2026-08-03',
    readCount: 87500,
    tags: ['综艺节目', '排名', '2026', '音乐竞演'],
    isHot: false,
    isFeatured: false,
    isDaily: true,
  },
  {
    id: '5',
    title: '某短视频平台头部网红直播翻车，人设崩塌',
    slug: 'influencer-live-fail',
    excerpt: '拥有千万粉丝的某知名网红在直播中因不当言论引发众怒，商品链接被下架，品牌方纷纷解约。该网红随后发布道歉视频，但网友并不买账。',
    content: `<p>昨晚，某短视频平台拥有超过2000万粉丝的知名网红在直播带货过程中，因发表不当言论引发全场哗然。直播画面被大量网友录屏并迅速传播，相关话题在各大平台登上热搜。</p><p>事件发生后，与该网红合作的多个知名品牌迅速发布声明，宣布终止与其的所有商业合作。其直播间的商品链接也相继被平台下架，预计直接经济损失超过千万元。</p><p>今日凌晨，该网红发布了一段长达8分钟的道歉视频，在视频中多次鞠躬致歉，表示"深刻认识到了自己的错误"，并承诺将暂停直播进行反思。</p><p>然而，网友们对此并不买账。评论区充斥着"又来演戏了""每次翻车都是这个套路"等留言。有网友甚至制作了该网红历次道歉的合集视频，被戏称为"年度道歉大赏"。</p><p>业内专家表示，网红经济的野蛮生长阶段已经过去，内容创作者需要更加注重社会责任和言行规范，否则随时可能面临"一夜回到解放前"的风险。</p>`,
    category: '网红爆料',
    categorySlug: 'wanghong-baoliao',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20live%20streaming%20studio%20setup%20with%20professional%20lighting%20and%20products%20display%2C%20modern%20influencer%20studio%2C%20warm%20ring%20light%20illumination%2C%20clean%20white%20desk%20with%20products%2C%20streaming%20equipment%20visible&width=800&height=450&seq=article-cover-05&orientation=landscape',
    author: '网红观察',
    publishDate: '2026-08-03',
    readCount: 201450,
    tags: ['网红', '直播翻车', '带货', '道歉'],
    isHot: true,
    isFeatured: true,
    isDaily: false,
  },
  {
    id: '6',
    title: '某地突发重大社会事件，官方通报最新进展',
    slug: 'major-social-incident',
    excerpt: '昨日某地发生一起引发全网关注的重大社会事件，相关部门已介入调查。官方今日发布最新通报，披露事件初步调查结果及后续处理方案。',
    content: `<p>昨日傍晚，某地发生一起重大社会事件，现场视频在社交平台迅速传播，引发全网高度关注。事件发生后，当地政府第一时间成立专项工作组，连夜开展调查处置工作。</p><p>今日上午，官方通过政务平台发布最新通报。通报显示，相关部门已经对事件进行了全面调查，初步查明了事件起因和经过，相关责任人已经被控制。</p><p>通报中还提到，政府将本着公开透明的原则，及时向社会公布事件调查进展。同时，相关部门已启动善后工作，确保受影响群众得到妥善安置。</p><p>此事件在网络上引发热烈讨论，多数网友对官方快速反应的態度表示认可，同时也呼吁要从根源上杜绝类似事件的发生。多位社会学者也发声，建议完善相关制度，建立长效预防机制。</p><p>目前，事件仍在进一步调查处理中，我们将持续关注后续进展。</p>`,
    category: '社会热点',
    categorySlug: 'shehui-redian',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20modern%20cityscape%20with%20buildings%20at%20sunset%2C%20urban%20scene%2C%20news%20reporting%20style%2C%20warm%20evening%20light%2C%20clean%20city%20streets%2C%20professional%20journalistic%20photography&width=800&height=450&seq=article-cover-06&orientation=landscape',
    author: '社会观察员',
    publishDate: '2026-08-02',
    readCount: 320100,
    tags: ['社会事件', '官方通报', '热点新闻', '民生'],
    isHot: true,
    isFeatured: false,
    isDaily: true,
  },
  {
    id: '7',
    title: '某组合成员疑似单飞，粉丝后援会联合发声',
    slug: 'group-member-solo-rumor',
    excerpt: '人气组合某成员被曝已与经纪公司解约，疑似准备单飞发展。该成员粉丝后援会联合发表声明，呼吁粉丝保持冷静，等待官方消息。',
    content: `<p>近日，关于某人气偶像组合成员A疑似准备单飞的消息在粉丝圈引发轩然大波。据业内人士透露，A已经与经纪公司就解约事宜进行了多轮谈判，双方在合约条款上存在较大分歧。</p><p>消息传出后，A的个人粉丝后援会与组合粉丝后援会罕见地联合发表声明，呼吁所有粉丝"保持冷静和理智，不要轻信未经证实的传闻，等待官方正式公告"。</p><p>这已经不是该组合第一次传出成员单飞的消息。去年，另一位成员也曾被传要单飞，但最终经纪公司发表声明否认，并宣布组合将以完整阵容回归。</p><p>然而，与上次不同的是，这次A本人及其经纪公司均未对传闻作出回应，这种沉默被不少粉丝解读为"默认"。</p><p>业内人士分析，如果A真的单飞，对该组合的商业价值将造成较大影响。该组合目前有多个代言合约和巡演计划，一旦出现人员变动，可能面临巨额违约金。</p>`,
    category: '明星动态',
    categorySlug: 'mingxing-dongtai',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20idol%20group%20on%20stage%20performance%20with%20colorful%20concert%20lighting%2C%20K-pop%20style%20stage%2C%20dynamic%20performance%20moment%2C%20energetic%20atmosphere%2C%20professional%20concert%20photography&width=800&height=450&seq=article-cover-07&orientation=landscape',
    author: '偶像追踪',
    publishDate: '2026-08-02',
    readCount: 189600,
    tags: ['偶像组合', '单飞', '解约', '粉丝后援会'],
    isHot: true,
    isFeatured: false,
    isDaily: false,
  },
  {
    id: '8',
    title: '年度电影票房突破500亿，国产片占比超七成',
    slug: 'annual-box-office-500-billion',
    excerpt: '截至今日，2026年中国电影年度总票房正式突破500亿元大关，其中国产影片票房占比超过72%，创历史新高。多部国产佳片口碑与票房双丰收。',
    content: `<p>据国家电影局最新数据，截至今日，2026年中国电影年度总票房正式突破500亿元大关，较去年同期增长约15%。更为可喜的是，国产影片票房占比达到了72.3%，创下历史新高。</p><p>今年上映的多部国产影片均取得了口碑与票房的双丰收。其中，科幻大片《星际迷航：新纪元》以68亿元票房暂居年度榜首，现实题材影片《人间烟火》以45亿元紧随其后，动画电影《山海经》则以38亿元排名第三。</p><p>业内人士分析，国产电影票房占比的持续提升，一方面得益于国产电影制作水平的不断提升，另一方面也反映了观众对本土故事和文化表达的强烈需求。</p><p>"中国电影正在经历一个黄金时代。"著名影评人张帆表示，"从类型多样化到技术水准，从故事深度到视觉效果，国产电影在各个方面都取得了长足进步。我相信未来还会有更多优秀作品涌现。"</p>`,
    category: '影视资讯',
    categorySlug: 'yingshi-zixun',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20modern%20cinema%20interior%20with%20red%20seats%20and%20large%20screen%2C%20luxurious%20movie%20theater%2C%20warm%20ambient%20lighting%2C%20empty%20theater%20with%20cinematic%20atmosphere%2C%20professional%20architectural%20photography&width=800&height=450&seq=article-cover-08&orientation=landscape',
    author: '电影观察家',
    publishDate: '2026-08-01',
    readCount: 76100,
    tags: ['电影票房', '国产电影', '年度数据', '文化产业'],
    isHot: false,
    isFeatured: true,
    isDaily: false,
  },
  {
    id: '9',
    title: '某选秀节目选手背景造假被扒，节目组紧急回应',
    slug: 'talent-show-fake-background',
    excerpt: '热门选秀节目《明日之星》中一位人气选手被网友扒出学历背景造假，引发舆论风波。节目组发布声明称正在核实，如属实将取消其参赛资格。',
    content: `<p>热门选秀节目《明日之星》正在热播中，但今日一位人气选手却陷入了"背景造假"风波。有网友通过社交媒体发布了详细证据，指该选手在节目中声称的"名校研究生学历"与实际情况不符。</p><p>根据网友扒出的信息，该选手实际仅为某普通院校的进修班学员，与"研究生"身份相去甚远。此消息一出，立刻在粉丝群体中引发巨大震动。</p><p>节目组在舆情发酵后迅速发布声明，表示已经注意到相关质疑，正在对选手提供的个人信息进行全面核实。"如果核实结果与选手申报信息不符，我们将根据比赛规则取消其参赛资格，并保留追究其相关责任的权利。"</p><p>该选手目前尚未对此事作出公开回应，但其社交账号的最新动态停留在三天前，评论区已经被网友们"攻陷"。</p><p>这已经不是选秀节目第一次出现选手背景造假的问题。去年另一档选秀节目中也曾曝出类似事件，涉事选手最终被取消资格并公开道歉。</p>`,
    category: '综艺节目',
    categorySlug: 'zongyi-jiemu',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20talent%20show%20audition%20stage%20with%20spotlight%20and%20judges%20table%2C%20reality%20TV%20show%20set%2C%20dramatic%20stage%20lighting%2C%20professional%20broadcast%20production%2C%20entertainment%20show%20atmosphere&width=800&height=450&seq=article-cover-09&orientation=landscape',
    author: '选秀追踪',
    publishDate: '2026-08-01',
    readCount: 143200,
    tags: ['选秀节目', '背景造假', '明日之星', '选手'],
    isHot: true,
    isFeatured: false,
    isDaily: true,
  },
  {
    id: '10',
    title: '知名导演新片开机，全明星阵容曝光',
    slug: 'famous-director-new-film',
    excerpt: '著名导演李安国的新片今日正式开机，此前一直保密的主演阵容终于揭晓。多位一线明星加盟，引发影迷高度期待。',
    content: `<p>著名导演李安国筹备三年的新片《归途》今日在横店影视城正式开机。此前一直处于保密状态的主演阵容也终于揭晓——由三位一线演员和两位实力派新人共同担任主演。</p><p>据现场工作人员透露，开机仪式低调而隆重，全体主创人员出席了仪式。导演李安国在简短发言中表示："这将是一部触动人心的作品，我们会全力以赴。"</p><p>《归途》是一部关于家庭和亲情的故事，讲述了三个不同年代的人物在时代变迁中的命运交织。剧本由导演本人亲自打磨两年，据看过剧本的业内人士透露，"这是一部笑中带泪的温馨之作"。</p><p>该片预计拍摄周期为三个月，暂定于2027年春节档上映。从阵容和题材来看，业内人士普遍看好该片的票房前景，有分析师预测最终票房有望突破30亿元。</p>`,
    category: '影视资讯',
    categorySlug: 'yingshi-zixun',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20film%20production%20set%20with%20camera%20crew%20and%20lighting%20equipment%2C%20professional%20movie%20shooting%20scene%2C%20behind%20the%20scenes%20cinematography%2C%20warm%20set%20lighting%2C%20film%20industry%20atmosphere&width=800&height=450&seq=article-cover-10&orientation=landscape',
    author: '影视前线',
    publishDate: '2026-08-01',
    readCount: 91200,
    tags: ['新片开机', '导演', '全明星阵容', '横店'],
    isHot: false,
    isFeatured: false,
    isDaily: false,
  },
  {
    id: '11',
    title: '某女星社交媒体晒豪宅引争议，网友：太高调了',
    slug: 'actress-luxury-mansion-controversy',
    excerpt: '某女星在社交平台晒出新购置的豪宅内景，装修奢华引发网友热议。有人羡慕有人批评，该女星随后删除了相关动态。',
    content: `<p>昨日，某知名女星在其社交媒体账号上分享了一组新家照片，展示其新近购置的豪宅内景。照片中可以看到超大的客厅空间、私人影院、室内游泳池等奢华设施，据网友估算，该豪宅市值至少在5000万元以上。</p><p>照片发布后，评论区迅速出现了两极分化的声音。一部分粉丝表示"姐姐辛苦了这么多年应该享受"，为偶像感到开心。但也有大量网友批评其"太高调""炫富"，认为在当前经济环境下，如此高调展示奢华生活不太合适。</p><p>争议发酵约三小时后，该女星悄悄删除了相关动态，但并未对此事作出任何说明。其工作室也保持沉默，没有回应媒体的询问。</p><p>这并非娱乐圈第一次发生"炫富"争议。此前多位明星因晒豪车、名牌包等引发过类似讨论。业内人士表示，在当前社交媒体环境下，明星更需要注意自己的公众形象塑造，过度炫耀个人财富可能会对个人品牌造成负面影响。</p>`,
    category: '明星动态',
    categorySlug: 'mingxing-dongtai',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20luxury%20modern%20villa%20interior%20with%20large%20windows%20and%20elegant%20furniture%2C%20high-end%20residential%20design%2C%20warm%20natural%20lighting%2C%20minimalist%20luxury%20style%2C%20spacious%20living%20room%20with%20modern%20decor&width=800&height=450&seq=article-cover-11&orientation=landscape',
    author: '娱乐圈观察',
    publishDate: '2026-07-31',
    readCount: 178300,
    tags: ['女星', '豪宅', '炫富', '争议'],
    isHot: false,
    isFeatured: true,
    isDaily: false,
  },
  {
    id: '12',
    title: '某短视频平台推出新政策，创作者收益将大幅提升',
    slug: 'platform-new-creator-policy',
    excerpt: '某头部短视频平台宣布推出全新创作者激励计划，大幅提高内容创作者的收益分成比例。此举被认为是平台间的创作者争夺战升级信号。',
    content: `<p>今日，某头部短视频平台正式宣布推出全新的创作者激励计划"星光计划3.0"。根据该计划，内容创作者的广告收益分成比例将从原来的50%提升至70%，优质原创内容还可获得额外的流量扶持和现金奖励。</p><p>平台方表示，此举旨在"回馈创作者，激励更多优质原创内容的产生"。据内部人士透露，该计划的总投入预算超过10亿元，是迄今为止行业内最大规模的创作者激励计划。</p><p>此消息一出，大量内容创作者纷纷表示欢迎。有头部创作者在社交平台发文称："终于等到这一天了！这会让更多有才华的人愿意全职投入内容创作。"</p><p>行业分析师认为，这一政策背后是短视频平台间日益激烈的创作者争夺战。"优质创作者是平台最核心的资产，谁拥有更多优秀的创作者，谁就能在下一阶段的竞争中占据优势。"</p><p>据悉，其他几家头部平台也在酝酿类似政策，预计近期将陆续公布。</p>`,
    category: '网红爆料',
    categorySlug: 'wanghong-baoliao',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20modern%20tech%20office%20with%20creative%20workspace%20design%2C%20social%20media%20company%20interior%2C%20bright%20open%20space%20with%20plants%2C%20modern%20digital%20creative%20environment%2C%20warm%20natural%20lighting&width=800&height=450&seq=article-cover-12&orientation=landscape',
    author: '科技娱乐',
    publishDate: '2026-07-31',
    readCount: 67400,
    tags: ['短视频', '创作者', '新政策', '收益'],
    isHot: false,
    isFeatured: false,
    isDaily: true,
  },
];

export const getHotArticles = (): Article[] => articles.filter(a => a.isHot);
export const getFeaturedArticles = (): Article[] => articles.filter(a => a.isFeatured);
export const getDailyArticles = (): Article[] => articles.filter(a => a.isDaily);
export const getArticlesByCategory = (slug: string): Article[] => articles.filter(a => a.categorySlug === slug);
export const getArticleById = (id: string): Article | undefined => articles.find(a => a.id === id);
export const getCategoryBySlug = (slug: string) => categories.find(c => c.slug === slug);